import React, { useState, useRef } from 'react';
import { Button, Input, Space } from 'antd'
import Highlighter from 'react-highlight-words';
import 'dayjs/locale/zh-cn';
import { SearchOutlined } from '@ant-design/icons';

export default function useTableSearch() {
    const searchInput = useRef()
    const [searchText, setsearchText] = useState('')
    const [searchedColumn, setsearchedColumn] = useState('')
    const getColumnSearchProps = (dataIndex, chineseType) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={searchInput}
                    placeholder={`请输入${chineseType ? chineseType : dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    > 查询 </Button>
                    <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}> 重置 </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current.select(), 100);
            }
        },
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                    text
                ),
    });
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();

        setsearchText(selectedKeys[0])
        setsearchedColumn(dataIndex)
    };
    const handleReset = clearFilters => {
        clearFilters();
        setsearchText('')
    };

    return {
        getColumnSearchProps
    }
};
